'use client';

import { useStore } from 'zustand';
import { useShallow } from 'zustand/react/shallow';

import { ConfigSaveErrorCode } from '@/domain/configuracao/helpers/saveError';
import { configuracaoStore } from '@/infrastructure/store/configuracaoStore';

/** Read AFTER an awaited mutation: the render closure still holds the value from before it. */
function readLastErrorCode(): ConfigSaveErrorCode | null {
  return configuracaoStore.getState().lastErrorCode;
}

export function useConfiguracao() {
  const state = useStore(
    configuracaoStore,
    useShallow((s) => ({
      config: s.config,
      loading: s.loading,
      failed: s.failed,
      saving: s.saving,
      load: s.load,
      update: s.update,
      addFeriado: s.addFeriado,
      updateFeriado: s.updateFeriado,
      removeFeriado: s.removeFeriado,
      restaurarFeriado: s.restaurarFeriado,
      removeFeriadoDefinitivo: s.removeFeriadoDefinitivo,
      setFeriadoConfirmado: s.setFeriadoConfirmado,
      setOrigemConfirmada: s.setOrigemConfirmada,
    })),
  );

  return { ...state, readLastErrorCode };
}
